/**
 * UI çevirileri (tr varsayılan). Makale içerikleri API’den gelir; burada site krom’u çevrilir.
 */
export const STORAGE_KEY_LOCALE = 'mutfak-ui-locale';

export const DEFAULT_LOCALE = 'tr';

export const SUPPORTED_LOCALES = /** @type {const} */ (['tr', 'en', 'fr']);

/** @typedef {'tr' | 'en' | 'fr'} AppLocale */

export const translations = {
  tr: {
    languageName: 'Dil',
    siteNameShort: 'Türk Mutfak Kültürü Atlası',
    meta: {
      navToggle: 'Menüyü aç/kapat',
    },
    nav: {
      home: 'Anasayfa',
      about: 'Hakkında',
      entries: 'Maddeler',
      authors: 'Yazarlar',
      advancedSearch: 'Gelişmiş Arama',
      contact: 'İletişim',
      entriesAll: 'Tüm Maddeler',
      authorsAll: 'Tüm Yazarlar',
      map: 'Harita',
    },
    search: {
      placeholder: `Türk Mutfağında Keşfe Çıkın`,
      tabTitle: 'Başlık',
      tabContent: 'İçerik',
      tabAuthor: 'Yazar',
      searching: 'Aranıyor...',
      noResults: 'Sonuç bulunamadı',
    },
    authorsPage: {
      loading: 'Yazarlar yükleniyor…',
      titleWithLetterRange: 'Tüm Yazarlar ({group})',
      entryCountLabel: '({count} madde)',
    },
    authorDetail: {
      loading: 'Yazar bilgileri yükleniyor…',
      notFound: 'Yazar bulunamadı.',
      profileAlt: 'Profil fotoğrafı',
      biography: 'Biyografi',
      readMore: 'Devamını oku',
      readLess: 'Daha az göster',
      entriesHeading: '{name} {surname} Maddeleri',
      noArticles: 'Bu yazara ait madde bulunmamaktadır.',
    },
    entriesPage: {
      loading: 'Maddeler yükleniyor…',
      all: 'Tümü',
      cityLabel: 'Şehir',
      allCities: 'Tüm şehirler',
      cityHint: 'Önce şehir seçin; kategoriler ve harfler buna göre listelenir.',
      refineLabel: 'Kategori ve harf',
      decorativeLineAlt: 'Dekoratif çizgi',
      noEntriesInCategory: 'Bu kategoride henüz madde bulunmuyor.',
      noEntriesForFilters: 'Seçilen kriterlere uygun madde bulunmuyor.',
      resultsCount: '{count} madde',
    },
    advancedSearchPage: {
      intro:
        'Arama özelliğini kullanarak ilgili maddeleri bulabilirsiniz. Arama, bir veya birkaç alanı doldurarak veya açılır listelerden bir öğe seçerek yapılabilir.',
      authorNames: 'Yazar İsimleri',
      selectOption: 'Seçiniz',
      titleField: 'Başlık',
      titlePlaceholder: 'Başlık giriniz',
      contentField: 'Metin',
      contentPlaceholder: 'Metin içinde aranacak kelime',
      keywordsPlaceholder: 'Anahtar kelimeleri giriniz (Enter veya virgül ile ayırın)',
      submit: 'Ara',
      searching: 'Aranıyor…',
      alertMinCriteria: 'Lütfen en az bir arama kriteri giriniz.',
    },
    searchResults: {
      loading: 'Yükleniyor…',
      advancedTitle: 'Gelişmiş Arama Sonuçları',
      advancedTitleAll: 'Gelişmiş Arama — Tüm Sonuçlar',
      forQuery: '“{query}” için arama sonuçları',
      resultsCount: '{count} sonuç bulundu',
      criteriaHeading: 'Arama Kriterleri:',
      authorIdFallback: 'Yazar ID: {id}',
      noResultsTitle: 'Sonuç bulunamadı',
      noResultsHint: 'Arama kriterlerinizi değiştirerek tekrar denemek için tıklayınız.',
    },
    welcome: {
      title: 'Türk Mutfağının Hafızasını Keşfedin',
      imageAlt: 'Türk Mutfak Kültürü Atlası ve Ansiklopedisi',
      body:
        'Binlerce yıllık birikim, yüzlerce yöresel lezzet, ortak bir kültürel hafıza… Türk mutfağı yalnızca yemeklerden değil; coğrafyadan, tarihten, geleneklerden, üretim biçimlerinden ve kuşaktan kuşağa aktarılan eşsiz bir kültürel mirastan oluşur. Türk Mutfak Kültürü Atlası ve Ansiklopedisi, bu zengin mirası bilimsel yöntemlerle araştırmak, belgelemek, korumak ve herkes için erişilebilir kılmak amacıyla hazırlanmıştır.\n\nAnadolu’dan Balkanlara, Orta Asya’dan Akdeniz’e uzanan geniş bir kültür coğrafyasının izlerini taşıyan Türk mutfağını; yemekleri, ürünleri, malzemeleri, üretim teknikleri, gelenekleri, tarihsel kökenleri ve bölgesel çeşitliliğiyle keşfedebilirsiniz. Atlas üzerinde yöreden yöreye ilerleyebilir, merak ettiğiniz bir yemeğin hikâyesine ulaşabilir, geçmişten günümüze değişen mutfak kültürünün izlerini sürebilirsiniz. Her tarif bir lezzeti, her lezzet bir coğrafyayı, her coğrafya ise bir kültürü anlatır. Şimdi Türk mutfağının büyük kültür haritasını keşfetmeye başlayın.',
    },
    latest: {
      sectionTitle: 'Yeni Eklenen Maddeler',
    },
    mapPage: {
      loading: 'Harita yükleniyor…',
      errorLoad: 'Harita verileri yüklenemedi',
      errorFetch: 'Harita verileri yüklenirken hata oluştu',
      noData: 'Haritada gösterilecek veri bulunamadı',
      locationFallback: 'Konum',
      locationCoords: 'Konum ({lat}, {lng})',
      stats: '{articles} makale • {authors} yazar',
    },
    articleDetail: {
      authorLabel: 'Yazar:',
      readingCustomizerClose: '[Kapat]',
      modalClose: 'Kapat',
      bibliography: 'Kaynakça',
      keywordsTitle: 'Anahtar Kelimeler',
      imageModalNavKeys: '📱 Gezinme: ← → tuşları',
      imageModalZoomHelp: '🔍 Yakınlaştırma: +/- tuşları veya çift tıklama',
      imageModalPanHelp: "✋ Kaydırma: Zoom'lanmış resmi sürükleyin",
      imageAriaPrev: 'Önceki resim',
      imageAriaNext: 'Sonraki resim',
      imageAriaZoomOut: 'Uzaklaştır',
      imageAriaZoomIn: 'Yakınlaştır',
      imageAriaReset: 'Sıfırla',
    },
    contact: {
      infoTitle: 'İletişim Bilgileri',
      formTitle: 'İletişim Formu',
      addressLine1: 'Üniversiteler Mah. Toplum Cad. No.: 5 06800',
      addressLine2: 'Çankaya / ANKARA',
      mapIframeTitle: 'AKM konumu',
      nameLabel: 'Adınız ve Soyadınız*',
      emailLabel: 'E-posta Adresiniz*',
      phoneLabel: 'Telefon Numaranız',
      messageLabel: 'Mesajınız*',
      emailPlaceholder: 'isim@ornek.com',
      phonePlaceholder: '05XXXXXXXXX',
      messagePlaceholder: 'Ayrıntılı olarak mesajınızı yazınız.',
      verificationLabel: 'Doğrulama:',
      captchaAnswerPlaceholder: 'Cevabı girin',
      captchaRefreshTitle: 'Yeni soru oluştur',
      submit: 'Gönder',
      sendSuccess: 'Mesajınız başarıyla gönderildi.',
      sendFailed: 'Mesaj gönderilemedi. Lütfen zorunlu alanları doldurun.',
      alertTooManyTriesWait: 'Çok fazla deneme! {seconds} saniye bekleyin.',
      alertSubmitTooFast: 'Çok hızlı gönderim! 30 saniye bekleyin.',
      alertCaptchaBlocked5Min: 'Çok fazla hatalı deneme! 5 dakika bekleyin.',
      alertWrongCaptcha: 'Yanlış cevap! {remaining} deneme hakkınız kaldı.',
      captchaBlockedHint: 'Çok fazla hatalı deneme! {seconds} saniye bekleyin.',
    },
    about: {
      title: 'AKMB Hakkında',
      intro: {
        p1: 'Atatürk Kültür Merkezi Başkanlığı bir bilim ve kültür akademisi niteliğinde olup Türk kültürü üzerinde, araştırma, yayın, tanıtım, teşvik ve ödüllendirme faaliyetlerini sürdürmekte, devletin ve toplumun öncelikleriyle yakından ilgilenmektedir.',
        p2: 'Atatürk Kültür Merkezi; kuruluşundan bu yana yüzlerce yayın yapmış, yurt içi ve yurt dışında çok sayıda konferans ve bilimsel toplantı düzenlemiş, çeşitli konularda belgeseller hazırlamıştır. Ayrıca bugüne kadar edebiyat, sanat tarihi, tiyatro, resim, Türk müziği ve ilişkili dallarında ödüllü yarışmalar açarak Türk kültürü üzerinde araştırma yapanlara teşvik mahiyetinde ödüller vermiştir. Atatürk Kültür Merkezi Başkanlığı, desteklediği küçük projelerle yanında, kurum içi uluslararası nitelikte kapsamlı projeler de yürütmektedir.',
        p3: 'Ülkemizin kültürel ve doğal mirasının korunması, değerlendirilmesi, tanıtılması ve gelecek kuşaklara aktarılması konusunda, bilim ve kültür kurumlarına büyük sorumluluklar düşmektedir. Atatürk Kültür Merkezi Başkanlığı bu sorumluluğun bilinciyle diğer kurumlarla iş birliği içinde faaliyetlerini sürdürmektedir.',
      },
      scope: {
        title: 'Kapsam ve Amaç',
        p1: 'Türk kültürünü bilimsel yöntemlerle araştırmak, tanıtmak, yaymak ve bu alandaki kişi ve kuruluşları destekleyip onlarla iş birliği yapmak misyonu ile Türk kültürü araştırmalarında ulusal ve uluslararası düzeyde en yetkin kurumlardan biri olmak ve temel değerleri yaşatarak millî kültürümüzü çağdaş medeniyetler seviyesi üzerine çıkarmak vizyonunu göz önünde bulunduran Kurumumuz, “Türk Mutfak Kültürü Atlası ve Ansiklopedisi Projesi” ile Türk mutfağına ve kültürel mirasımıza katkıda bulunma temennisi ile toplumun bütün kesimlerinin kolaylıkla erişimine imkân verecek güvenilir bir açık kaynağa dönüştürülmesi amacı çerçevesinde elde edilen bilgilerin elektronik ortamda yayımlamayı, yeme-içme alanı unsurlarının kültürel ve tarihsel kökenlerini bölgesel çeşitliliği ile çağdaş yansımalarını akademik standartlarda ortaya koyarak sürdürülebilir kültürel hafızaya katkı sağlamayı hedeflemektedir.',
        p2: 'Ulusal ve uluslararası platformlarda yer almak üzere üç dille (Türkçe-İngilizce-Fransızca) hazırlanması planlanan proje, kültür ve gastronomi diplomasisi bağlamında stratejik bir girişimdir. Proje, Türk mutfağının dünya mutfaklarına etkisi ile yurt dışı Türk mutfak uygulamalarının göç ve diaspora kimlikleri bağlamında incelenmesi bakımından bir ilk olup Türk mutfak kültürü ve gastronomi mirasının uluslararası alanda tanınırlığını artırarak kültürel diplomasi aracılığıyla Türkiye’nin mutfak kültürü kimliğini pekiştirmiş olacaktır.',
        p3: 'Somut olmayan kültürel miras unsurlarının belgelenmesi ve gelecek kuşaklara aktarılması, gastronomi turizmine, yerel-sürdürülebilir kalkınmaya ve kültürel diplomasiye katkı sağlayacak olan proje; yurt içi ve yurt dışında bulunan üniversiteler, araştırmacılar ve kültür kurumları için bilimsel veri altyapısı oluşturacaktır.',
      },
      team: {
        title: 'Proje Ekibi',
        decorativeAlt: 'Dekoratif çizgi',
        projectLead: 'Proje Yürütücüsü',
        executiveCommittee: 'Yürütme Komisyonu',
        scienceBoard: 'Bilim Kurulu',
        languageEditors: 'Dil Editörleri',
        translators: 'Çevirmenler',
        coordinationTeam: 'Proje Koordinasyon Ekibi',
        frenchEditorRole: 'Fransızca Dil Editörü',
        englishEditorRole: 'İngilizce Dil Editörü',
        turkishEditorRole: 'Türkçe Dil Editörü',
        frenchAssistantRole: 'Fransızca Dil Editör Yardımcısı',
        englishAssistantRole: 'İngilizce Dil Editör Yardımcısı',
      },
    },
    footer: {
      aboutLong: 'Türk Mutfak Kültürü Atlası ve Ansiklopedisi Hakkında',
      disclaimer: 'Sorumluluk Reddi',
      privacy: 'Gizlilik Politikası',
      contactHeading: 'İletişim',
      addressLabel: 'Adres:',
      phoneLabel: 'Telefon:',
      emailLabel: 'E-posta:',
      addressLine: 'Üniversiteler Mah. Toplum Cad. No.5 Çankaya/ANKARA',
      copyright: 'Atatürk Kültür Merkezi Başkanlığı. Tüm hakları saklıdır.',
    },
  },

  en: {
    languageName: 'Language',
    siteNameShort: 'Atlas and Encyclopedia of Turkish Culinary Culture',
    meta: {
      navToggle: 'Toggle navigation',
    },
    nav: {
      home: 'Home',
      about: 'About',
      entries: 'Entries',
      authors: 'Authors',
      advancedSearch: 'Advanced search',
      contact: 'Contact',
      entriesAll: 'All entries',
      authorsAll: 'All authors',
      map: 'Map',
    },
    search: {
      placeholder: 'Detailed Search in TMK-atlas',
      tabTitle: 'Title',
      tabContent: 'Content',
      tabAuthor: 'Author',
      searching: 'Searching…',
      noResults: 'No results found',
    },
    authorsPage: {
      loading: 'Loading authors…',
      titleWithLetterRange: 'All authors ({group})',
      entryCountLabel: '({count} entries)',
    },
    authorDetail: {
      loading: 'Loading author…',
      notFound: 'Author not found.',
      profileAlt: 'Profile photo',
      biography: 'Biography',
      readMore: 'Read more',
      readLess: 'Show less',
      entriesHeading: 'Entries by {name} {surname}',
      noArticles: 'No entries are linked to this author.',
    },
    entriesPage: {
      loading: 'Loading entries…',
      all: 'All',
      cityLabel: 'City',
      allCities: 'All cities',
      cityHint: 'Choose a city first; categories and letters update to match.',
      refineLabel: 'Category and letter',
      decorativeLineAlt: 'Decorative line',
      noEntriesInCategory: 'No entries in this category yet.',
      noEntriesForFilters: 'No entries match the selected filters.',
      resultsCount: '{count} entries',
    },
    advancedSearchPage: {
      intro:
        'Use search to find relevant entries. You can fill in one or more fields or choose an option from the dropdown lists.',
      authorNames: 'Author names',
      selectOption: 'Select',
      titleField: 'Title',
      titlePlaceholder: 'Enter title',
      contentField: 'Text',
      contentPlaceholder: 'Word to search for in the text',
      keywordsPlaceholder: 'Enter keywords (separate with Enter or comma)',
      submit: 'Search',
      searching: 'Searching…',
      alertMinCriteria: 'Please enter at least one search criterion.',
    },
    searchResults: {
      loading: 'Loading…',
      advancedTitle: 'Advanced search results',
      advancedTitleAll: 'Advanced search — All results',
      forQuery: 'Search results for “{query}”',
      resultsCount: '{count} results found',
      criteriaHeading: 'Search criteria:',
      authorIdFallback: 'Author ID: {id}',
      noResultsTitle: 'No results found',
      noResultsHint: 'Click to try again with different search criteria.',
    },
    welcome: {
      title: 'Welcome to the Atlas and Encyclopedia of Turkish Culinary Culture',
      imageAlt: 'Atlas and Encyclopedia of Turkish Culinary Culture',
      body:
        "With the mission of researching, promoting, and disseminating Turkish culture using scientific methods, and supporting and collaborating with individuals and organizations in this field, AKMB aims to be one of the most competent institutions at the national and international level in Turkish culture research, and to elevate our national culture to the level of contemporary civilizations by preserving its fundamental values. In this context, AKMB, with its “Atlas and Encyclopedia of Turkish Culinary Culture Project,” aims to contribute to Turkish cuisine and our cultural heritage by publishing the obtained information electronically, transforming it into a reliable open source that will allow easy access to all segments of society, and contributing to sustainable cultural memory by presenting the cultural and historical origins of food and beverage elements, their regional diversity, and contemporary reflections at an academic standard.",
    },
    latest: {
      sectionTitle: 'Recently added articles',
    },
    mapPage: {
      loading: 'Loading map…',
      errorLoad: 'Map data could not be loaded',
      errorFetch: 'An error occurred while loading map data',
      noData: 'No data to display on the map',
      locationFallback: 'Location',
      locationCoords: 'Location ({lat}, {lng})',
      stats: '{articles} entries • {authors} authors',
    },
    articleDetail: {
      authorLabel: 'Author:',
      readingCustomizerClose: '[Close]',
      modalClose: 'Close',
      bibliography: 'References',
      keywordsTitle: 'Keywords',
      imageModalNavKeys: '📱 Navigate: ← → keys',
      imageModalZoomHelp: '🔍 Zoom: +/- keys or double-click',
      imageModalPanHelp: '✋ Pan: Drag the zoomed image',
      imageAriaPrev: 'Previous image',
      imageAriaNext: 'Next image',
      imageAriaZoomOut: 'Zoom out',
      imageAriaZoomIn: 'Zoom in',
      imageAriaReset: 'Reset view',
    },
    contact: {
      infoTitle: 'Contact information',
      formTitle: 'Contact form',
      addressLine1: 'Üniversiteler Mah. Toplum Cad. No.: 5, 06800',
      addressLine2: 'Çankaya / ANKARA, Türkiye',
      mapIframeTitle: 'AKM location',
      nameLabel: 'Full name*',
      emailLabel: 'Email address*',
      phoneLabel: 'Phone number',
      messageLabel: 'Your message*',
      emailPlaceholder: 'name@example.com',
      phonePlaceholder: '05XXXXXXXXX',
      messagePlaceholder: 'Please write your message in detail.',
      verificationLabel: 'Verification:',
      captchaAnswerPlaceholder: 'Enter the answer',
      captchaRefreshTitle: 'New question',
      submit: 'Send',
      sendSuccess: 'Your message was sent successfully.',
      sendFailed: 'Could not send the message. Please fill in the required fields.',
      alertTooManyTriesWait: 'Too many attempts! Please wait {seconds} seconds.',
      alertSubmitTooFast: 'You are submitting too quickly! Please wait 30 seconds.',
      alertCaptchaBlocked5Min: 'Too many incorrect attempts! Please wait 5 minutes.',
      alertWrongCaptcha: 'Wrong answer! You have {remaining} attempt(s) left.',
      captchaBlockedHint: 'Too many incorrect attempts! Please wait {seconds} seconds.',
    },
    about: {
      title: 'About AKMB (Presidency of the Atatürk Cultural Center)',
      intro: {
        p1:
          'Presidency of Atatürk Culture Center functions as an academy of science and culture, conducting research, publishing, promoting, and recognizing achievements in Turkish culture, while closely aligning with the priorities of the state and society.',
        p2:
          'Since its establishment, the Atatürk Cultural Center has published hundreds of works, organized numerous conferences and academic meetings both in Türkiye and abroad, and produced documentaries on a variety of topics. In addition, it has organized award-winning competitions in literature, art history, theater, painting, Turkish music, and related fields, offering prizes to encourage those conducting research on Turkish culture. The Atatürk Cultural Center has supported small-scale projects and has also carried out—and continues to carry out—comprehensive, internationally oriented projects within the institution.',
        p3:
          'Scientific and cultural institutions bear a great responsibility for the preservation, promotion, and dissemination of our country’s cultural and natural heritage, as well as for passing it on to future generations. With a full awareness of this responsibility, the Atatürk Cultural Center continues its activities in collaboration with other institutions.',
      },
      scope: {
        title: 'Scope and Purpose',
        p1:
          'With the mission of researching, promoting, and disseminating Turkish culture using scientific methods, and supporting and collaborating with individuals and organizations in this field, AKMB aims to be one of the most competent institutions at the national and international level in Turkish culture research, and to elevate our national culture to the level of contemporary civilizations by preserving its fundamental values. In this context, AKMB, with its “Atlas and Encyclopedia of Turkish Culinary Culture Project,” aims to contribute to Turkish cuisine and our cultural heritage by publishing the obtained information electronically, transforming it into a reliable open source that will allow easy access to all segments of society, and contributing to sustainable cultural memory by presenting the cultural and historical origins of food and beverage elements, their regional diversity, and contemporary reflections at an academic standard.',
        p2:
          'Planned for presentation on national and international platforms and prepared in three languages (Turkish, English, and French), this project is a strategic initiative within the context of cultural and gastronomic diplomacy. The project is groundbreaking in that it examines the influence of Turkish cuisine on world cuisines and Turkish culinary practices abroad within the context of migration and diaspora identities. It aims to enhance the international recognition of Turkish culinary culture and gastronomic heritage, thereby reinforcing Türkiye’s culinary identity through cultural diplomacy.',
        p3:
          'This project, which will document and transmit intangible cultural heritage elements to future generations, may contribute to gastronomic tourism, local sustainable development, and cultural diplomacy and will create a scientific data infrastructure for universities, researchers, and cultural institutions both domestically and internationally.',
      },
      team: {
        title: 'Project Team',
        decorativeAlt: 'Decorative divider line',
        projectLead: 'Project Manager',
        executiveCommittee: 'Executive Committee',
        scienceBoard: 'Science Board',
        languageEditors: 'Language Editors',
        translators: 'Translators',
        coordinationTeam: 'Project Coordination Team',
        frenchEditorRole: 'French Language Editor',
        englishEditorRole: 'English Language Editor',
        turkishEditorRole: 'Turkish Language Editor',
        frenchAssistantRole: 'Editor Assistant for French Language',
        englishAssistantRole: 'Editor Assistant for English Language',
      },
    },
    footer: {
      aboutLong: 'About the Atlas and Encyclopedia of Turkish Culinary Culture',
      disclaimer: 'Disclaimer',
      privacy: 'Privacy policy',
      contactHeading: 'Contact',
      addressLabel: 'Address:',
      phoneLabel: 'Phone:',
      emailLabel: 'Email:',
      addressLine: 'Üniversiteler Mah. Toplum Cad. No.5 Çankaya/ANKARA, Türkiye',
      copyright: 'Presidency of the Atatürk Cultural Center. All rights reserved.',
    },
  },

  fr: {
    languageName: 'Langue',
    siteNameShort: 'Atlas et Encyclopédie de la Culture Culinaire Turque',
    meta: {
      navToggle: 'Ouvrir le menu',
    },
    nav: {
      home: 'Page d’accueil',
      about: 'À propos',
      entries: 'Notices',
      authors: 'Auteurs',
      advancedSearch: 'Recherche avancée',
      contact: 'Contact',
      entriesAll: 'Tous les articles',
      authorsAll: 'Tous les auteurs',
      map: 'Carte',
    },
    search: {
      placeholder: 'Recherche détaillée dans l’Atlas TMK',
      tabTitle: 'Titre',
      tabContent: 'Contenu',
      tabAuthor: 'Auteur',
      searching: 'Recherche en cours…',
      noResults: 'Aucun résultat',
    },
    authorsPage: {
      loading: 'Chargement des auteurs…',
      titleWithLetterRange: 'Tous les auteurs ({group})',
      entryCountLabel: '({count} articles)',
    },
    authorDetail: {
      loading: 'Chargement de l’auteur…',
      notFound: 'Auteur introuvable.',
      profileAlt: 'Photo de profil',
      biography: 'Biographie',
      readMore: 'Lire la suite',
      readLess: 'Réduire',
      entriesHeading: 'Articles de {name} {surname}',
      noArticles: 'Aucun article n’est associé à cet auteur.',
    },
    entriesPage: {
      loading: 'Chargement des articles…',
      all: 'Tous sujets',
      cityLabel: 'Ville',
      allCities: 'Toutes les villes',
      cityHint: 'Choisissez d’abord une ville ; les catégories et les lettres s’adaptent.',
      refineLabel: 'Catégorie et lettre',
      decorativeLineAlt: 'Ligne décorative',
      noEntriesInCategory: 'Aucun article dans cette catégorie pour le moment.',
      noEntriesForFilters: 'Aucun article ne correspond aux filtres sélectionnés.',
      resultsCount: '{count} articles',
    },
    advancedSearchPage: {
      intro:
        'La recherche permet de trouver les articles pertinents. Vous pouvez remplir un ou plusieurs champs ou choisir une option dans les listes déroulantes.',
      authorNames: 'Noms des auteurs',
      selectOption: 'Sélectionnez',
      titleField: 'Titre',
      titlePlaceholder: 'Saisissez le titre',
      contentField: 'Texte',
      contentPlaceholder: 'Mot à rechercher dans le texte',
      keywordsPlaceholder: 'Saisissez les mots-clés (séparés par Entrée ou virgule)',
      submit: 'Rechercher',
      searching: 'Recherche…',
      alertMinCriteria: 'Veuillez saisir au moins un critère de recherche.',
    },
    searchResults: {
      loading: 'Chargement…',
      advancedTitle: 'Résultats de la recherche avancée',
      advancedTitleAll: 'Recherche avancée — Tous les résultats',
      forQuery: 'Résultats de recherche pour « {query} »',
      resultsCount: '{count} résultat(s) trouvé(s)',
      criteriaHeading: 'Critères de recherche :',
      authorIdFallback: 'ID auteur : {id}',
      noResultsTitle: 'Aucun résultat',
      noResultsHint: 'Cliquez pour réessayer avec d’autres critères.',
    },
    welcome: {
      title: "Bienvenue sur le site de l’Atlas et Encyclopédie de la Culture Culinaire Turque",
      imageAlt: 'Atlas et Encyclopédie de la Culture Culinaire Turque',
      body:
        `Le projet intitulé « Atlas et Encyclopédie de la Culture Culinaire Turque » s’inscrit dans cette perspective de valorisation et de transmission du patrimoine culinaire turc. Cette initiative vise à contribuer à la promotion de la cuisine turque et du patrimoine culturel national à travers la création d’une plateforme numérique ouverte, scientifique et fiable, accessible à l’ensemble de la société. Le projet a pour objectif de publier, sous format électronique, des données documentées portant sur les traditions culinaires turques, leurs origines historiques et culturelles, leur diversité régionale ainsi que leurs tendances culinaires contemporaines. En proposant une approche scientifique et interdisciplinaire des pratiques alimentaires, il entend contribuer à la constitution d’une mémoire culturelle durable et offrir une ressource de référence destinée aussi bien au grand public qu’au monde académique.

`,
    },
    latest: {
      sectionTitle: 'Articles récemment ajoutés',
    },
    mapPage: {
      loading: 'Chargement de la carte…',
      errorLoad: 'Les données de la carte n’ont pas pu être chargées',
      errorFetch: 'Une erreur s’est produite lors du chargement de la carte',
      noData: 'Aucune donnée à afficher sur la carte',
      locationFallback: 'Emplacement',
      locationCoords: 'Emplacement ({lat}, {lng})',
      stats: '{articles} articles • {authors} auteurs',
    },
    articleDetail: {
      authorLabel: 'Auteur :',
      readingCustomizerClose: '[Fermer]',
      modalClose: 'Fermer',
      bibliography: 'Bibliographie',
      keywordsTitle: 'Mots-clés',
      imageModalNavKeys: '📱 Navigation : touches ← →',
      imageModalZoomHelp: '🔍 Zoom : touches +/- ou double-clic',
      imageModalPanHelp: '✋ Déplacement : faites glisser l’image agrandie',
      imageAriaPrev: 'Image précédente',
      imageAriaNext: 'Image suivante',
      imageAriaZoomOut: 'Zoom arrière',
      imageAriaZoomIn: 'Zoom avant',
      imageAriaReset: 'Réinitialiser la vue',
    },
    contact: {
      infoTitle: 'Coordonnées',
      formTitle: 'Formulaire de contact',
      addressLine1: 'Üniversiteler Mah. Toplum Cad. N° : 5, 06800',
      addressLine2: 'Çankaya / ANKARA, Türkiye',
      mapIframeTitle: 'Localisation de l’AKM',
      nameLabel: 'Nom et prénom*',
      emailLabel: 'Adresse e-mail*',
      phoneLabel: 'Numéro de téléphone',
      messageLabel: 'Votre message*',
      emailPlaceholder: 'nom@exemple.com',
      phonePlaceholder: '05XXXXXXXXX',
      messagePlaceholder: 'Veuillez rédiger votre message en détail.',
      verificationLabel: 'Vérification :',
      captchaAnswerPlaceholder: 'Saisissez la réponse',
      captchaRefreshTitle: 'Nouvelle question',
      submit: 'Envoyer',
      sendSuccess: 'Votre message a été envoyé avec succès.',
      sendFailed: 'Échec de l’envoi. Veuillez remplir les champs obligatoires.',
      alertTooManyTriesWait: 'Trop de tentatives ! Veuillez patienter {seconds} secondes.',
      alertSubmitTooFast: 'Envoi trop rapide ! Veuillez patienter 30 secondes.',
      alertCaptchaBlocked5Min: 'Trop de réponses incorrectes ! Veuillez patienter 5 minutes.',
      alertWrongCaptcha: 'Réponse incorrecte ! Il vous reste {remaining} tentative(s).',
      captchaBlockedHint: 'Trop de réponses incorrectes ! Veuillez patienter {seconds} secondes.',
    },
    about: {
      title: '',
      introSectionTitle: 'Présentation institutionnelle',
      intro: {
        p1:
          'Institution scientifique et culturelle de référence, Le Centre culturel Atatürk a pour mission d’étudier, de promouvoir et de transmettre la culture turque selon des méthodes scientifiques, tout en soutenant les acteurs institutionnels et académiques engagés dans ce domaine et en développant avec eux des collaborations durables. Par ses activités de recherche, de publication et de diffusion culturelle, il aspire à compter parmi les institutions les plus reconnues, aux niveaux national et international, dans le champ des études consacrées à la culture turque, tout en contribuant à la préservation et à la transmission des valeurs fondamentales du patrimoine culturel national dans le contexte du monde contemporain.',
        
      },
      scope: {
        title: 'Champ et objectifs du projet',
        p1:
          'Le projet intitulé « Atlas et Encyclopédie de la Culture Culinaire Turque » s’inscrit dans cette perspective de valorisation et de transmission du patrimoine culinaire turc. Cette initiative vise à contribuer à la promotion de la cuisine turque et du patrimoine culturel national à travers la création d’une plateforme numérique ouverte, scientifique et fiable, accessible à l’ensemble de la société. Le projet a pour objectif de publier, sous format électronique, des données documentées portant sur les traditions culinaires turques, leurs origines historiques et culturelles, leur diversité régionale ainsi que leurs tendances culinaires contemporaines. En proposant une approche scientifique et interdisciplinaire des pratiques alimentaires, il entend contribuer à la constitution d’une mémoire culturelle durable et offrir une ressource de référence destinée aussi bien au grand public qu’au monde académique.',
      
      },
      team: {
        title: 'Équipe du projet',
        decorativeAlt: 'Ligne décorative',
        projectLead: 'Responsable du projet',
        executiveCommittee: 'Commission exécutive',
        scienceBoard: 'Conseil scientifique',
        languageEditors: 'Éditeurs linguistiques',
        translators: 'Traducteurs et assistants éditoriaux',
        coordinationTeam: 'Équipe de coordination du projet',
        frenchEditorRole: 'Éditrice de langue française',
        englishEditorRole: 'Éditeur de langue anglaise',
        turkishEditorRole: 'Éditeur de langue turque',
        frenchAssistantRole: 'Assistante éditoriale – langue française',
        englishAssistantRole: 'Assistants éditoriaux – langue anglaise',
      },
    },
    footer: {
      aboutLong: "À propos de l'Atlas et Encyclopédie de la Culture Culinaire Turque",
      disclaimer: 'Clause de non-responsabilité',
      privacy: 'Politique de confidentialité',
      contactHeading: 'Contact',
      addressLabel: 'Adresse :',
      phoneLabel: 'Téléphone :',
      emailLabel: 'Courriel :',
      addressLine: 'Üniversiteler Mah. Toplum Cad. No.5 Çankaya/ANKARA, Turquie',
      copyright: 'Présidence du Centre culturel Atatürk. Tous droits réservés.',
    },
  },
};

/** Dil seçicide gösterilen yerel adlar */
export const LOCALE_LABELS = {
  tr: 'Türkçe',
  en: 'English',
  fr: 'Français',
};
